@if (aiSummaries && surveyForm && attendeeSurvey) {
  <form class="ai-summary-survey" [formGroup]="surveyForm">
    <span class="title-survey">
      {{
        !isGuest || !user
          ? 'How was the sound and video quality?'
          : 'Enter email to unlock your personalized meeting summary and access it again later'
      }}
    </span>
    @if (isGuest || !user) {
      <mat-form-field class="badging-form w-full" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="text" formControlName="email" />
        <mat-error>Email is required</mat-error>
      </mat-form-field>
    }
    @if (question1?.questionType === questionType.SCALE) {
      <div class="rating-wrapper">
        @if (!user || isGuest) {
          <span class="rating-title">How was the sound and video quality?</span>
        }
        <div class="star-selector-wrapper">
          @for (ratingId of starArray; track ratingId; let i = $index) {
            <button
              [id]="'star_' + i"
              class="star-icon-button"
              (click)="changeRating(ratingId, question1?.surveyQuestionId)"
            >
              <mat-icon>
                {{ showIcon(ratingId) }}
              </mat-icon>
            </button>
          }
        </div>
        <div class="stars-label">
          <span>Very Poor</span>
          <span>Excellent</span>
        </div>
      </div>
    }
    @if (question2?.questionType === questionType.TEXT_INPUT) {
      <mat-form-field class="w-full">
        <mat-label>Tell us more!</mat-label>
        <textarea
          matInput
          placeholder="feedback"
          formControlName="tellUs"
          (change)="changeTellUsMore(question2?.surveyQuestionId)"
        ></textarea>
      </mat-form-field>
    }
    <div class="w-full flex justify-end">
      <app-home-button class="mr-2" [color]="'white'" (click)="goToHomePage()"> Exit to Scoot Home </app-home-button>
      <app-home-button [disabled]="(isGuest && !surveyForm.valid) || isLoading" (click)="submitAiSurvey()">
        {{ isGuest || !user ? 'Get Access' : 'View Report' }}
      </app-home-button>
    </div>
  </form>
} @else {
  <h2 class="survey-dialog-title bg-color-ocean" mat-dialog-title>
    {{ title }}
    <div class="close-button-container">
      <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="close()"
        >close</mat-icon
      >
    </div>
  </h2>
  <div class="container">
    <div style="text-align: center">
      <div class="question-section">
        <div class="carousel">
          @for (slide of slides; track slide; let i = $index) {
            @if (i === currentSlide) {
              <div class="slide" @carouselAnimation>
                @if (question1) {
                  <div>
                    @if (question1.questionType === questionType.SCALE) {
                      <scale-survey-card [question]="question1"></scale-survey-card>
                    }
                    @if (question1.questionType === questionType.TEXT_INPUT) {
                      <text-input-survey-card [question]="question1"></text-input-survey-card>
                    }
                    @if (question1.questionType === questionType.SELECTOR) {
                      <selector-survey [question]="question1"></selector-survey>
                    }
                  </div>
                }
                @if (question2) {
                  <div>
                    @if (question2.questionType === questionType.SCALE) {
                      <scale-survey-card [question]="question2"></scale-survey-card>
                    }
                    @if (question2.questionType === questionType.TEXT_INPUT) {
                      <text-input-survey-card [question]="question2"></text-input-survey-card>
                    }
                    @if (question2.questionType === questionType.SELECTOR) {
                      <selector-survey [question]="question2"></selector-survey>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      </div>
      <div style="margin-top: -16px">
        @for (slide of slides; track slide; let i = $index) {
          <span id="i" [ngClass]="i === currentSlide ? 'dot-selected' : 'dot'"></span>
        }
      </div>
      @if (!isLastSlide()) {
        <div class="button-section">
          <div>
            <button class="next-button" mat-raised-button (click)="onNextClick()">Next</button>
          </div>
          <div>
            <button class="skip-button" mat-button (click)="onNextClick()">Skip</button>
          </div>
        </div>
      }
      @if (isLastSlide()) {
        <div>
          <button class="submit-button" mat-button (click)="submitAndClose()">Submit</button>
        </div>
      }
    </div>
  </div>
}
